import { useFormikContext } from 'formik'

import { VIEWING_FORM_FIELD_NAME } from '../../../RentalPortalViewingFormModal.constants'

import { getViewingFormModeResetValues } from './useViewingFormChangeFields.utils'

export function useViewingFormChangeFields() {
  const { setFieldValue } = useFormikContext()

  function handleChangeTimeSource() {
    setFieldValue(VIEWING_FORM_FIELD_NAME.slot, null)
  }

  function handleChangeMode(mode) {
    Object.entries(getViewingFormModeResetValues(mode)).forEach(
      ([name, value]) => {
        setFieldValue(name, value)
      }
    )
  }

  return { handleChangeMode, handleChangeTimeSource }
}
